export const APP_SIDEBAR = {
  MUTATIONS: {
    SHOW: 'appSidebar/SHOW',
    HIDE: 'appSidebar/HIDE'
  }
}

const state = {
  show: true
}

const mutations = {
  [APP_SIDEBAR.MUTATIONS.SHOW] (state, data) {
    state.show = true
  },
  [APP_SIDEBAR.MUTATIONS.HIDE] (state, data) {
    state.show = false
  }
}

export const appSidebar = {
  state,
  mutations
}
